module.exports = require('./assignIn');



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/extend.js
 ** module id = 31
 ** module chunks = 0
 **/